<!-- Translated: skip -->
<template>
  <Modal @close="localCloseModal" :wide="false" width="500px">
    <h2 v-if="SITE_CONFIG.accomodations.date_picker_help.summer_title">OBS! {{ SITE_CONFIG.accomodations.date_picker_help.summer_title }}</h2>

      <p v-if="SITE_CONFIG.accomodations.date_picker_help.summer_info2">
        <span v-html="SITE_CONFIG.accomodations.date_picker_help.summer_info2"></span>
      </p>

      <p v-if="SITE_CONFIG.accomodations.date_picker_help.summer_info3">
        <span v-html="SITE_CONFIG.accomodations.date_picker_help.summer_info3"></span>
      </p>

    <div style="text-align:center;margin-top: 4px;">
      <button class="" @click="click">Välj {{[params.startDate, params.endDate] | dateRange}}</button>
      <p style="margin-bottom: 0;">
        &nbsp;
      </p>

      <a href="#" class="small-link" @click.prevent="cancel">Avbryt och sök nya datum</a>
    </div>

  </Modal>
</template>

<script>
import { mapMutations } from 'vuex';
import Modal from '@/components/components/Modal';
// import moment from 'moment';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
  },
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
    ...mapMutations([
      'closeModal',
    ]),
    localCloseModal() {
      this.params.cancel();
      this.closeModal();
    },
    cancel() {
      this.params.cancel();
      this.closeModal();
    },
    click() {
      this.params.click();
      this.closeModal();
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

h2
  font-size: 20px;
  font-weight: 900;
  text-align: left;
  color: #262626;
  united-heavy()
  uppercase()

.modalo
  text-align left

.small-link
  text-decoration underline
  font-size 14px
  color deep-blue
  font-weight bold
  font-family "Barlow Condensed"
  margin-top 1em
  display inline-block
</style>



// WEBPACK FOOTER //
// SummerConfirmationModal.vue?616e0360